<template>
  <div class="cookie__content">
    <CookieText :text="text" />
  </div>
</template>

<script>
import CookieText from '../CookieText';

export default {
  name: 'CookieContent',

  components: {
    CookieText,
  },

  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.cookie__content {
  display: inline;

  @include mq(ipadP) {
    display: block;
    flex: 1 1 0;
  }
}
</style>
